
import axios from "axios";

import { IP } from "utils/Host";

// zmiana procesora w grupie z poziomu technologia stage
export function dropStageRozetnijPrzerwe(draggedId,targetId,dropDate,refreshGantAll) {

// id = procesor id
console.log("dropStageRozetnijPrzerwe")
  
  axios
  .get(IP + "API_0006_gant_procedura_rozetnij_przerwe/"+draggedId+"/"+targetId+"/"+dropDate+"/" + sessionStorage.getItem("token"))
    .then((res) => {
refreshGantAll()

    })
}


